// ======================================================================
// File Name       : ImportUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as Path from '../constants/PathConstants';

export function getAction(route) {
  let path = {
    importPath: '',
    getListPath: '',
    importDrillServer: false,
    getListDrillServer: false,
    returnListPath: '',
    returnListTitle: '',
    isShowNote: false, // Step 11.0.0
  };
  switch (route) {
    case Path.ENTERPRISE_IMPORT:
      path = {
        importPath: 'enterprise/EditList',
        importDrillServer: false,
        getListPath: 'enterprise/EditListResult',
        getListDrillServer: false,
        title: '企業',
        enterpriseId: 1,
        csvSamplePath: '/manual/csvsample/enterprise_content.zip',
        returnListPath: Path.ENTERPRISE_LIST,
        returnListTitle: '企業管理に戻る',
      };
      break;
    case Path.SERVICE_IMPORT:
      path = {
        importPath: 'service/EditList',
        importDrillServer: false,
        getListPath: 'service/EditListResult',
        getListDrillServer: false,
        title: 'サービス',
        enterpriseId: 1,
        csvSamplePath: '/manual/csvsample/service_content.zip',
        returnListPath: Path.SERVICE_LIST,
        returnListTitle: 'サービス一覧に戻る',
      };
      break;
    case Path.SUPERUSER_IMPORT:
      path = {
        importPath: 'superuser/EditList',
        importDrillServer: false,
        getListPath: 'superuser/EditListResult',
        getListDrillServer: false,
        title: 'SuperUser',
        enterpriseId: 1,
        csvSamplePath: '/manual/csvsample/superuser_content.zip',
        returnListPath: Path.SUPERUSER_LIST,
        returnListTitle: 'SuperUser管理に戻る',
      };
      break;
    case Path.AUTHORITY_IMPORT:
      path = {
        importPath: 'userAuthority/EditList',
        getListPath: 'userAuthority/EditListResult',
        importDrillServer: false,
        getListDrillServer: false,
        title: 'ロール',
        csvSamplePath: '/manual/csvsample/authority_content.zip',
        returnListPath: Path.AUTHORITY_LIST,
        returnListTitle: 'ロール一覧に戻る',
      };
      break;
    case Path.GROUP_IMPORT:
      path = {
        importPath: 'group/EditList',
        getListPath: 'group/EditListResult',
        importDrillServer: false,
        getListDrillServer: false,
        title: 'ユーザーグループ',
        csvSamplePath: '/manual/csvsample/group_content.zip',
        returnListPath: Path.GROUP_LIST,
        returnListTitle: 'ユーザーグループ一覧に戻る',
        isShowNote: true, // Step 11.0.0
      };
      break;
    case Path.USER_IMPORT:
      path = {
        importPath: 'user/EditList',
        getListPath: 'user/EditListResult',
        importDrillServer: false,
        getListDrillServer: false,
        title: 'ユーザー',
        csvSamplePath: '/manual/csvsample/user_content.zip',
        returnListPath: Path.USER_LIST,
        returnListTitle: 'ユーザー管理に戻る',
        isShowNote: true, // Step 11.0.0
      };
      break;
    case Path.CONTENT_QUESTION_IMPORT:
      path = {
        importPath: 'private/QuestionPackageRegister',
        getListPath: 'QuestionPackageRegisterHistory',
        getListDrillServer: true,
        importDrillServer: true,
        title: '問題',
        csvSamplePath: '/manual/csvsample/question_content.zip',
        returnListPath: Path.CONTENT_QUESTION_LIST,
        returnListTitle: '問題一覧に戻る',
      };
      break;
    case Path.CONTENT_VIDEO_IMPORT:
      path = {
        importPath: 'video/EditList',
        getListPath: 'video/EditListResult',
        importDrillServer: false,
        getListDrillServer: false,
        title: 'ビデオ',
        csvSamplePath: '/manual/csvsample/video_content.zip',
        returnListPath: Path.CONTENT_VIDEO_LIST,
        returnListTitle: 'ビデオ一覧に戻る',
        isShowNote: true, // Step 11.0.0
      };
      break;
    case Path.CONTENT_DRILL_IMPORT:
      path = {
        importPath: 'private/DrillPackageRegister',
        importDrillServer: true,
        getListPath: 'DrillPackageRegisterHistory',
        getListDrillServer: true,
        title: 'ドリル',
        csvSamplePath: '/manual/csvsample/drill_content.zip',
        returnListPath: Path.CONTENT_DRILL_LIST,
        returnListTitle: 'ドリル一覧に戻る',
      };
      break;
    case Path.CONTENT_DISTRIBUTION_IMPORT:
      path = {
        importPath: 'contentsPermission/EditServiceList',
        importDrillServer: false,
        getListPath: 'contentsPermission/GetServiceListResult',
        getListDrillServer: false,
        titleDistribution: 'コンテンツ配布先情報',
        csvSamplePath: '/manual/csvsample/distributionContent_content.zip',
        returnListPath: Path.CONTENT_DISTRIBUTION_LIST,
        returnListTitle: 'コンテンツ配布管理に戻る',
        isShowNote: true, // Step 11.0.0
      };
      break;
    case Path.COURSE_DISTRIBUTION_IMPORT:
      path = {
        importPath: 'contentsPermission/EditCourseList',
        importDrillServer: false,
        getListPath: 'contentsPermission/GetCourseListResult',
        getListDrillServer: false,
        titleDistribution: 'コース配布先情報',
        csvSamplePath: '/manual/csvsample/distributionCourse_content.zip',
        returnListPath: Path.CONTENT_DISTRIBUTION_LIST,
        returnListTitle: 'コンテンツ配布管理に戻る',
        isShowNote: true, // Step 11.0.0
      };
      break;
    case Path.CONTENT_LINK_IMPORT:
      path = {
        importPath: 'link/EditList',
        importDrillServer: false,
        getListPath: 'link/EditListResult',
        getListDrillServer: false,
        title: 'リンク',
        csvSamplePath: '/manual/csvsample/link_content.zip',
        returnListPath: Path.CONTENT_LINK_LIST,
        returnListTitle: 'リンク一覧に戻る',
        isShowNote: true, // Step 11.0.0
      };
      break;
    case Path.CONTENT_DOCUMENT_IMPORT:
      path = {
        importPath: 'document/EditList',
        importDrillServer: false,
        getListPath: 'document/EditListResult',
        getListDrillServer: false,
        title: 'ドキュメント',
        csvSamplePath: '/manual/csvsample/document_content.zip',
        returnListPath: Path.CONTENT_DOCUMENT_LIST,
        returnListTitle: 'ドキュメント一覧に戻る',
        isShowNote: true, // Step 11.0.0
      };
      break;
    case Path.COURSE_IMPORT:
      path = {
        importPath: 'container/EditStructureList',
        importDrillServer: false,
        getListPath: 'container/EditStructureResult',
        getListDrillServer: false,
        title: 'コース',
        csvSamplePath: '/manual/csvsample/container.zip',
        returnListPath: Path.COURSE_LIST,
        returnListTitle: 'コース一覧に戻る',
        isShowNote: true, // Step 11.0.0
      };
      break;
    case Path.ENTERPRISE_NOTIFICATION_IMPORT:
      path = {
        importPath: 'noticeForEnterprise/EditList',
        importDrillServer: false,
        getListPath: 'noticeForEnterprise/EditListResult',
        getListDrillServer: false,
        title: '企業向けお知らせ',
        enterpriseId: 1,
        csvSamplePath: '/manual/csvsample/noticeForEnterprise_content.zip',
        returnListPath: Path.ENTERPRISE_NOTIFICATION_LIST,
        returnListTitle: '企業向けお知らせ一覧に戻る',
        isShowNote: true, // Step 11.0.0
      };
      break;
    case Path.SERVICE_NOTIFICATION_IMPORT:
      path = {
        importPath: 'notice/EditList',
        importDrillServer: false,
        getListPath: 'notice/EditListResult',
        getListDrillServer: false,
        title: 'サービス向けお知らせ',
        csvSamplePath: '/manual/csvsample/notice_content.zip',
        returnListPath: Path.SERVICE_NOTIFICATION_LIST,
        returnListTitle: 'お知らせ一覧に戻る',
        isShowNote: true, // Step 11.0.0
      };
      break;
    case Path.ADAPTIVE_META: {
      path = {
        csvSamplePath: '/manual/csvsample/adaptiveData_content.zip',
      };
      break;
    }
    default:
      break;
  }
  return path;
}
